module.exports = __webpack_public_path__ + "img/stock0.2fcfea3e.png";